module.exports = __webpack_public_path__ + "static/img/Bachelor_010467.5744791.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010467.jpg
// module id = 170
// module chunks = 0